import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnimationLinear: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"animation-linear"} maskId="square-filled-radius-0-stroke-1-IconAnimationLinear"><path fillRule="evenodd" clipRule="evenodd" d="M21.2072 3.49995L3.50008 21.2071L2.79297 20.5L20.5001 2.79285L21.2072 3.49995Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAnimationLinear;
